import React from 'react';

import { SettingActionCard } from '@/sections/settings/components';

import { HealthStatusIcon } from './HealthStatusIcon';

export interface HealthCheckCardProps {
  title: string;
  status: 'success' | 'error' | 'unknown';
  message: string;
}

/**
 * Health check card following Settings page pattern
 *
 * Displays health check information in horizontal card layout
 * with title/message on left and status badge on right.
 *
 * Wraps SettingActionCard for consistent styling across the app.
 */
export const HealthCheckCard: React.FC<HealthCheckCardProps> = ({
  title,
  status,
  message,
}) => {
  return (
    <SettingActionCard
      action={<HealthStatusIcon status={status} />}
      data-testid={`health-check-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex flex-col gap-1">
        <h4 className="font-bold">{title}</h4>
        <span className="text-chariot-text-secondary text-xs">{message}</span>
      </div>
    </SettingActionCard>
  );
};
